"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InfoBox;
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _react = _interopRequireDefault(require("react"));
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    info: {
      alignItems: 'center',
      background: 'rgba(0, 119, 200, 0.12)',
      border: '1px solid #0077C8',
      borderRadius: 4,
      boxSizing: 'border-box',
      color: theme.isDark() ? theme.palette.text.secondary : theme.palette.grey[700],
      display: 'flex',
      padding: theme.spacing(1.5),
      width: '100%'
    },
    infoIcon: {
      color: theme.palette.primary.main,
      marginRight: theme.spacing(1.5)
    },
    infoText: {
      lineHeight: '12px'
    }
  };
});
function InfoBox(_ref) {
  var id = _ref.id,
    text = _ref.text;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.info
  }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.InfoOutlined, {
    className: classes.infoIcon
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.infoText,
    id: id,
    variant: "caption"
  }, text));
}